import { delay, put, takeEvery } from 'redux-saga/effects';

import * as actions from './rootUiActions';

export function* removeDialogActionWatcher() {
  yield takeEvery(actions.removeDialog, function* showNextDialog({ payload, meta }) {
    if (meta?.animate) {
      // Wait until dialog's dismiss animation is finished
      yield delay(1000);
      // Then remove the dialog from the store, unless it was reopened with the same id meanwhile
      yield put(actions.removeDialog(payload, { ...meta, animate: false, onlyIfHidden: true }));
    } else {
      // Wait until the previous dialog is dismissed.
      yield delay(2000);
      yield put(actions.showNextDialog());
    }
  });
}

export default [removeDialogActionWatcher];
